import { BaseComponent } from '../../base.component.js';

class Icon extends BaseComponent {

  render({ src, isLanguageSpecific = false, className }, _, { imgGlobal, img }) {
    const _src = isLanguageSpecific ? img(src) : imgGlobal(src);
    return (
      <div>
        <img className={className || "icon"} src={_src} onError={() => this.badgeService.notifyImageError(_src)} />
      </div>
    );
  }

}

/**
 * Only use title and tuevSeal properties when using this component. The rest of them are initialized by the parent accordion component.
 * @typedef {RenderableProps} _AbAccordionItem_Props
 * @property {string} title - Title text for the accordion item header
 * @property {boolean} isOpen - Specifies whether this accordion item is open or closed. For good results this component needs to be inside an Accordion component, and make sure there are no 2 items open in the same time.
 * @property {boolean} tuevSeal - Specifies whether to show the TUEV seal icon or not.
 * @property {string} openItemClass - The css class name of the open item, it can be ab-accordion-item--open (>=3 items accordion), ab-accordion-item--open-1 (1 item accordion), ab-accordion-item--open-2 (2 items accordion). This should only be used by the accordion component.
 * @property {number} height - The height of the accordion item. We want all items to be the same size for now. Only used by the accordion parent component.
 * @property {number} topPosition - The top position of the item. This is computed in the parent accordion component, and should not be used by anyone else.
 * @property {function()} onClick - Callback function called when an accordion item is clicked. This is only used by the parent accordion component.
*/
const AbAccordionItem = ({
  children,
  title,
  isOpen,
  tuevSeal,
  openItemClass,
  height,
  size,
  topPosition,
  onClick,
  zIndex
}, { composition }) => {
  let className = "ab-accordion-item";
  className += isOpen ? ` ${openItemClass}` : "";
  className += ` ab-size-${size}`;

  const imageSrc = composition ? composition.parts.tuvSeal.imageSrc : null;

  return (
    <div
      onClick={onClick}
      className={className}
      style={{ top: `${topPosition}px`, height: `${height}px`, zIndex: zIndex + (isOpen ? 1 : 0) }}>
      <div class="header">
        <Icon src="check-icon.svg" />
        <div className="title">{title}</div>
        {tuevSeal && <Icon src={imageSrc || 'tuev-badge.svg'} className="ab-tuv-mark icon32" />}
        {!isOpen && <Icon src="arrow.svg" className="icon arrow-down" />}
        {isOpen && <Icon src="close-icon.svg" className="icon close" />}
      </div>

      <div className={'content ' + (isOpen ? '' : 'ab-behind')}>
        {children}
      </div>
    </div>
  );
};

export default AbAccordionItem;
